export const PLUS_SIZE = 20;
export const CROSS_SIZE = 10;
export const PLUS_BORDER = 2;
export const PLUS_STEM_WIDTH = 8;
export const PLUS_STEM_HEIGHT = 2;
export const PLUS_STEM_GAP = 2;

export const LEAF_ADORNMENT_WIDTH = PLUS_SIZE + PLUS_STEM_GAP + PLUS_STEM_WIDTH;
export const LEAF_ADORNMENT_HEIGHT = Math.max(PLUS_SIZE, PLUS_STEM_HEIGHT);
